import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DownOutlined from '@ant-design/icons/DownOutlined';

import sx from './styled/sx';

const SortChip = (props) => {
	const { id, value, label, open, onClick } = props;

	return (
		<Stack key={id} direction="row" spacing={0.5} alignItems="baseline">
			{label && <Typography color="secondary">{label}</Typography>}
			{value && (
				<Button
					sx={{ px: 0.75, pr: 1.25, py: 0.25, minWidth: 0 }}
					variant="text"
					onClick={onClick}
					endIcon={<DownOutlined style={sx.icon({ open })} />}
				>
					{value}
				</Button>
			)}
		</Stack>
	);
};

SortChip.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	value: PropTypes.string,
	label: PropTypes.string,
	open: PropTypes.bool,
	onClick: PropTypes.func,
};

export default SortChip;
